import { render, staticRenderFns } from "./advAuthTaxcodeVerified.vue?vue&type=template&id=3b0557fa&scoped=true&"
import script from "./advAuthTaxcodeVerified.vue?vue&type=script&lang=js&"
export * from "./advAuthTaxcodeVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0557fa",
  null
  
)

export default component.exports